import React from 'react';

const Card = ({ title, subtitle, sourceImage, onClick }) => {
  return (
    <div className={`max-w-[290px] mx-auto bg-white border border-gray-200 rounded-lg`}>
      <img className="rounded-t-lg h-[290px] w-full object-fit" src={sourceImage} alt={title} />
      <div className="px-8 py-5 flex flex-col justify-between text-left space-y-4">
        <h5 className="text-base font-bold tracking-tight text-left">{title}</h5>
        <h5 className="text-sm tracking-tight text-left">{subtitle}</h5>
        <button
          onClick={onClick}
          className="flex justify-center items-center py-3 text-sm font-semibold text-center bg-[#F2FAF7] text-primary-500 rounded-lg"
        >
          Lihat Selengkapnya
        </button>
      </div>
    </div>
  );
};

export default Card;
